/* eslint-disable */
import Vue from 'vue';

import ShardsVue from 'shards-vue';
// import VueToast from 'vue-toast-notification';
import VueToast from 'vue-toast-notification'

import 'vue-toast-notification/dist/theme-default.css';
// import 'vue-toast-notification/dist/theme-sugar.min.css'

// Styles
import 'bootstrap/dist/css/bootstrap.css';
import '@/scss/shards-dashboards.scss';
import '@/assets/scss/date-range.scss';
// Core
import App from './App.vue';
import router from './router';
//vuex
import store from './store'
// Layouts
import Default from '@/layouts/Default.vue';
import SweetModal from 'sweet-modal-vue/src/plugin.js'
Vue.use(require('vue-moment'));

// import VueTabs from 'vue-nav-tabs'
// import 'vue-nav-tabs/themes/vue-tabs.css'


import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.use(VueSweetalert2)


// Vue.use(VueTabs)
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);

Vue.use(SweetModal)
Vue.use(VueToast);

import loading from 'vuejs-loading-screen';
Vue.use(loading, {
  bg: "#cecece",
  slot: `
<div class="text-center">
  <div style="width: 3rem; height: 3rem;" class="spinner-border text-primary text-center" role="status">
  </div><BR/>
  <p class="text-center" style="font-weight:bold">Espere...</p>

</div>`
})

function checkVersion() {
  console.log('checkVersion')
  fetch("/version.json", { cache: "no-cache" })
    .then((response) => response.json())
    .then((data) => {
      const newVersion = data.version;
      const currentVersion = localStorage.getItem("version")
      if (currentVersion && newVersion != currentVersion) {
        console.log('nueva version')
        window.location.reload(true)
      }
      localStorage.setItem("version", newVersion)
    })
    .catch((err) => console.error("error al verificar version", err))
}

checkVersion()
setInterval(() => {
  console.log('verificando versión')
  checkVersion()
}, 60000);

ShardsVue.install(Vue);
// Vue.$toast.open(
//   {
//     message:'Nuevo mensaje Chat!',
//     type:'success',
//     position: 'top-right'
// });

Vue.component('default-layout', Default);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
